import { InjectableClass } from '@fino/lib-injection';

export class FinanceBulkImportService extends InjectableClass {
  constructor() {
    'ngInject';
    super({  });
  }
}
